import React from 'react';
import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const DeclinedIndicator = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        backgroundColor: '#FF5252',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <CloseIcon sx={{ fontSize: 16, color: 'white' }} />
    </Box>
    <Typography variant="subtitle2" component="span">
      Declined
    </Typography>
  </Box>
);
